import { iShortPublication } from "../../core/models/iPublication";
import { iSubscriptionPackage } from "../../core/models/iSubscriptionPackage";

export function filterBySubscriptionPackages(
    publications: iShortPublication[],
    packageIds: number[],
): iShortPublication[] {
    if (!packageIds.length) return publications;

    return publications.filter(({ subscriptionPackageIds }) =>
        subscriptionPackageIds.some(id => packageIds.includes(id)),
    );
}

export function getSubscriptionPackageNames(
    packageIds: number[],
    packages: iSubscriptionPackage[],
): string {
    return packages
        .filter(({ id }) => packageIds.includes(id))
        .map(({ name }) => name)
        .join(", ");
}

// Excel splits clipboard text on tabs and newlines, so they must not survive inside a cell.
// A leading quote stops spreadsheets from evaluating formula-like text pasted into a cell.
const toTsvCell = (value: string | number | null): string => {
    const text = `${value ?? ""}`.replace(/[\t\r\n]+/g, " ");
    return /^\s*[=+\-@]/.test(text) ? `'${text}` : text;
};

export function toTsv(headers: string[], rows: (string | number | null)[][]): string {
    return [headers, ...rows]
        .map(row => row.map(toTsvCell).join("\t"))
        .join("\n");
}
